import { render, staticRenderFns } from "./MyReports.vue?vue&type=template&id=345ffefc"
import script from "./MyReports.vue?vue&type=script&lang=js"
export * from "./MyReports.vue?vue&type=script&lang=js"
import style0 from "./MyReports.vue?vue&type=style&index=0&id=345ffefc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports